import main from "./main/main.js";

export default {
  main
};
